import Toasts from './Toasts.svelte'

export default Toasts
